import React, { useContext } from 'react'
import ClienteSelect from '../../components/molecules/ClienteSelect'

export default function Brand({ context }) {
  const { clienti, selectedClientId, setSelectedClientId, setBrand } = useContext(context)

  return (
    <ClienteSelect
      id="clienteSelection"
      label="Cliente"
      clienti={clienti}
      selectedClientId={selectedClientId || ''}
      onChange={(value) => {
        setSelectedClientId(value)
        const selectedCliente = clienti.find((cliente) => String(cliente.id) === String(value))
        setBrand(selectedCliente?.nome || '')
      }}
      isRequired
      helpText={
        <>
          Seleziona il <b>cliente</b>. Il backend sincronizza il campo legacy `brand`.
        </>
      }
      showCreateLink
    />
  )
}
